import { Component, OnInit, Input, Output, OnChanges, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss']
})
export class TablePaginationComponent implements OnInit {

  @Input() itemCount: number;
  @Input() rowsCount: number = 20;
  @Input() pageNumber: number = 1;
  @Output() onModelChange = new EventEmitter<number>();

  pageList: number[] = [];


  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.pageList = [];
    for(var i = 0;i!=this.pageNumber;i++){
      this.pageList.push(i+1);
    }
  }

  onNextClicked() {
    this.pageNumber = this.pageNumber + 1;
    this.onModelChange.emit(this.pageNumber);
  }

  onPrevClicked() {
    if (this.pageNumber != 1) {
      this.pageNumber = this.pageNumber - 1;
      this.onModelChange.emit(this.pageNumber);
    }
  }

  onPageNumberClicked(page: number){
    if(this.pageNumber != page){
      this.pageNumber = page;
      this.onModelChange.emit(this.pageNumber);
    }
  }

}
